import { isAgentGridSource } from '@/utils/authBrand';

export const AGENT_GRID_TITLE = 'AgentGrid.io';
export const AGENT_GRID_IMAGE = 'https://projects.animaapp.com/static/img/agentgrid-panel.2c4357ed.jpg';
const AUTH_PATHS = ['/device', '/login'];

export const applyAuthMetadata = (route) => {
  const isAgentGrid = AUTH_PATHS.includes(route.path) && isAgentGridSource(route.query);
  document.title = isAgentGrid ? AGENT_GRID_TITLE : 'Anima';
  ['og:title', 'og:image'].forEach((property) => {
    document.head.querySelectorAll(`meta[property="${property}"]`).forEach((tag) => tag.remove());
    if (isAgentGrid) {
      const tag = document.createElement('meta');
      tag.setAttribute('property', property);
      tag.content = property === 'og:title' ? AGENT_GRID_TITLE : AGENT_GRID_IMAGE;
      document.head.appendChild(tag);
    }
  });
};
